module.exports = __webpack_public_path__ + "static/author-5-e136d9c201a059b0a331ca460a867e53.jpg";